import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Table } from "@/components/v2";
import { servicePartnerTagColumns } from "./lib/constants/servicePartnerTagColumns.tsx";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";
import { fetchServicePartnerTags } from "@/lib/api/resources/servicePartnerTags.ts";

export const ServicePartnerTagList = () => {
  const [page, setPage] = useState<number>(1);

  const servicePartnerTagQuery = useQuery({
    queryKey: ["service-partner-tags", page],
    queryFn: () => fetchServicePartnerTags({ page }),
  });

  return (
    <>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/service-partners/tags/create">
          <Button icon={<PlusOutlined />}>Nieuwe tag</Button>
        </Link>
      </Space>
      <Table
        columns={servicePartnerTagColumns}
        dataSource={servicePartnerTagQuery.data?.member}
        loading={servicePartnerTagQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: servicePartnerTagQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
        rowKey="id"
      />
    </>
  );
};
